import React, { useState, useEffect } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import '../App.css';

const Market = () => {
  const [cryptoData, setCryptoData] = useState({});
  const [gainers, setGainers] = useState([]);
  const [losers, setLosers] = useState([]);
  
    useEffect(() => {
        const fetchData = async () => {
            const requestOptions = {
                method: 'GET',
                redirect: 'follow',
                headers: {
                    Authorization: `Bearer ${process.env.REACT_APP_COINCAP_API_KEY}`
                }
            };
            try{
            const response = await fetch(
                'https://rest.coincap.io/v3/assets', requestOptions);
            if (!response.ok) {
                throw new Error('HTTP error! status: $ {response.status');
            }
            
            const result = await response.json();
            const changes = result.data.map(e => parseFloat(e.changePercent24Hr));
            const volumes = result.data.map(e => parseFloat(e.volumeUsd24Hr));

            setCryptoData({
            btcDominance: formatNumber(
                parseFloat((result.data.find(a=>a.symbol==='BTC').marketCapUsd ) / 
                result.data.reduce((sum,a)=>sum+parseFloat(a.marketCapUsd ),0)*100)),
            avgChange: formatNumber(changes.reduce((sum,a)=>sum+a,0) / changes.length),
            avgVolume: formatNumber(volumes.reduce((sum,a)=>sum+a,0) / volumes.length),
            positives: formatNumber((changes.filter(a => a > 0).length / changes.length)*100)
            })

            const top = [...result.data]
            .sort((a, b) => b.changePercent24Hr  - a.changePercent24Hr )
            .slice(0, 10)
            .map(c => ({
              name: c.name,
              symbol: c.symbol.toUpperCase(),
              change: parseFloat(c.changePercent24Hr).toFixed(2),
            }));
          setGainers(top);

          const bottom = [...result.data]
            .sort((a, b) => a.changePercent24Hr - b.changePercent24Hr)
            .slice(0, 10)
            .map(c => ({
              name: c.name,
              symbol: c.symbol.toUpperCase(),
              change: parseFloat(c.changePercent24Hr).toFixed(2),
            }));
          setLosers(bottom);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    },[]);
  
    const formatNumber = (number) => {
        if (!number) return 'NA' ;
        const num = parseFloat(number);
        if (num >=1e9) return `${(num / 1e9).toFixed(2)} B`;
        if (num >=1e6) return `${(num / 1e6).toFixed(2)} M`;
        if (num < 1e6) return `${num.toFixed(1)}`
        return num.toLocaleString();
    }

    const labelMap = {
        btcDominance: "Bitcoin Dominance",
        avgChange: "Market Average Change",
        avgVolume: "Average Volume",
        positives: "Positive Performers",
    };
    const unitMap = {
        btcDominance: "%",
        avgChange: "%",
        avgVolume: "",
        positives: "%"
    };


  return cryptoData ? (
    <section>
      <h1 className='font-bold text-3xl my-8 mx-4'>Crypto Market</h1>
      <p className='text-xl text-gray-400 my-4 mx-4'>Deep dive into cryptocurrency market trends and analysis</p>
      <div className='flex flex-wrap mx-2'>
        {Object.entries(cryptoData).map(([key, value]) => (
        <div key={key} className="m-2 p-8 bg-color1 shadow-[0_0_10px_rgba(0,0,0,0.3)] dark:bg-gradient-to-br dark:from-[#09090b] dark:to-zinc-800 dark:border dark:border-zinc-700 w-[23%] rounded-xl">
            <p className='text-md text-gray-400 mb-4'>{labelMap[key] || key}</p>
            <p className='text-2xl font-bold'>{value}{unitMap[key]}</p>
        </div>
        ))}
      </div>
      <div className="mx-4 my-8 p-8 bg-color1 shadow-[0_0_10px_rgba(0,0,0,0.3)] dark:bg-gradient-to-br dark:from-[#09090b] dark:to-zinc-800 dark:border dark:border-zinc-700 w-[95%] rounded-xl">
        <span className='flex items-center gap-2 mb-4'>
          <TrendingUp color="#10B981" /><h2 className='text-2xl text-emerald-500'>Top Gainers (24h)</h2>
        </span>
        {gainers.map((coin, i) => (
          <div key={i} className='flex mb-6 justify-between items-center'>
            <span><p className='text-xl font-bold'>{coin.name} </p>
            <p className='text-md text-gray-400'>{coin.symbol}</p></span>
            <p className='text-lg text-white font-bold rounded-full p-2 bg-emerald-500 w-32 text-center'>+ {coin.change}%</p>
          </div>
        ))}
      </div>
      <div className="mx-4 my-8 p-8 bg-color1 shadow-[0_0_10px_rgba(0,0,0,0.3)] dark:bg-gradient-to-br dark:from-[#09090b] dark:to-zinc-800 dark:border dark:border-zinc-700 w-[95%] rounded-xl">
        <span className='flex items-center gap-2 mb-4'>
          <TrendingDown color="#F87171" /><h2 className='text-2xl text-red-400'>Top Losers (24h)</h2>
        </span>
        {losers.map((coin, i) => (
          <div key={i} className='flex mb-6 justify-between items-center'>
            <span><p className='text-xl font-bold'>{coin.name} </p>
            <p className='text-md text-gray-400'>{coin.symbol}</p></span>
            <p className='text-lg text-white font-bold rounded-full p-2 bg-red-400 w-32 text-center'>{coin.change}%</p>
          </div>
        ))}
      </div>
    </section>
  ) : (
    <p>Loading...</p>
  );
}
export default Market
